import {WebappLanguageSchema} from '@cohort/shared/schema/common';
import {CustomTermsRecordSchema} from '@cohort/shared/schema/common/customTerms';
import {z} from 'zod';

export const CustomTermsASchema = z.object({
  data: z.record(WebappLanguageSchema, CustomTermsRecordSchema),
});
export type CustomTermsADto = z.infer<typeof CustomTermsASchema>;
